export const portfolios = [
  {
    id: 1,
    name: "Portafolio Deuda Mezzanine",
    projects: [
      { id: 1, startMonth: 1, exitMonth: 25, interestRate: 0.25, capitalDistribution: 0.25 },
      { id: 2, startMonth: 3, exitMonth: 39, interestRate: 0.25, capitalDistribution: 0.17 },
      { id: 3, startMonth: 2, exitMonth: 38, interestRate: 0.25, capitalDistribution: 0.08 },
      { id: 4, startMonth: 2, exitMonth: 38, interestRate: 0.20, capitalDistribution: 0.25 },
      { id: 5, startMonth: 3, exitMonth: 39, interestRate: 0.20, capitalDistribution: 0.17 },
      { id: 6, startMonth: 4, exitMonth: 40, interestRate: 0.20, capitalDistribution: 0.08 }
    ]
  },
  {
    id: 2,
    name: "Portafolio Venture Debt",
    projects: [
      { id: 7, startMonth:  1, exitMonth: 25, interestRate: 0.0, capitalDistribution: 0.25, exitMultiple: 3.0 },
      { id: 8, startMonth:  3, exitMonth: 39, interestRate: 0.0, capitalDistribution: 0.125, exitMultiple: 1.5 },
      { id: 9, startMonth:  2, exitMonth: 38, interestRate: 0.0, capitalDistribution: 0.125, exitMultiple: 2.0 },
      { id: 10, startMonth: 2, exitMonth: 38, interestRate: 0.12, capitalDistribution: 0.25, exitMultiple: 3.0 },
      { id: 11, startMonth: 3, exitMonth: 39, interestRate: 0.12, capitalDistribution: 0.125, exitMultiple: 1.5 },
      { id: 12, startMonth: 4, exitMonth: 40, interestRate: 0.12, capitalDistribution: 0.125, exitMultiple: 2.0 }
    ]
  },
  {
    id: 3,
    name: "Bono Nee'k",
    projects: [
      { id: 13, startMonth: 1, exitMonth: 37, interestRate: 0.16, capitalDistribution: 1.0 },
      // { id: 14, startMonth: 2, exitMonth: 38, interestRate: 0.10, capitalDistribution: 0.0 },
      // { id: 15, startMonth: 3, exitMonth: 39, interestRate: 0.12, capitalDistribution: 0.0 },
      // { id: 16, startMonth: 4, exitMonth: 40, interestRate: 0.14, capitalDistribution: 0.0 },
      // { id: 17, startMonth: 5, exitMonth: 41, interestRate: 0.17, capitalDistribution: 0.0 },
      // { id: 18, startMonth: 6, exitMonth: 42, interestRate: 0.21, capitalDistribution: 0.0 }
    ]
  },
  {
    id: 4,
    name: "Nota Nee'k",
    projects: [
      { id: 19, startMonth: 1, exitMonth: 25, interestRate: 0.12, capitalDistribution: 1.0 },
      // { id: 20, startMonth: 2, exitMonth: 38, interestRate: 0.11, capitalDistribution: 0.19 },
      // { id: 21, startMonth: 3, exitMonth: 39, interestRate: 0.13, capitalDistribution: 0.18 },
      // { id: 22, startMonth: 4, exitMonth: 40, interestRate: 0.15, capitalDistribution: 0.18 },
      // { id: 23, startMonth: 5, exitMonth: 41, interestRate: 0.18, capitalDistribution: 0.15 },
      // { id: 24, startMonth: 6, exitMonth: 42, interestRate: 0.23, capitalDistribution: 0.12 }
    ]
  }
]; 
